/** Guest-chat language: the global session setting (persisted per token). */

export interface LanguageOption {
  code: string;
  label: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: "ko", label: "한국어" },
  { code: "en", label: "English" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
];

export function storageKey(token: string): string {
  return `meshcore-guest-lang:${token}`;
}

export function readStoredLanguage(token: string): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(storageKey(token));
}

export function writeStoredLanguage(token: string, lang: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(storageKey(token), lang);
}
